import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import Button from '@ecp/common/src/components/button/bo/Button';

import { isManagerValue } from '@bo-recoil/common/user/atom';
import FormAccordion from '@bo-components/common/form/FormAccordion';
import SiteBasicInfo from './detail-basic/SiteBasicInfo';
import ClientInfo from './detail-basic/ClientInfo';
import DomainInfo from './detail-basic/DomainInfo';
import MemberInfo from './detail-basic/MemberInfo';
import SettleInfo from './detail-basic/SettleInfo';
import EtcInfo from './detail-basic/EtcInfo';
import { TERMINATED } from '../consts/SiteConst';

// 사이트상세 기본정보 영역 페이지
const DetailSiteBasicInfo = ({
  handleEditClick,
  siteBasicInfo,
  subsidiaryList,
  jobGroupList,
  redirectUrlList,
  applyExceptPayMeanList,
  setShowEntryMeanPopup,
  setShowRegPopup,
  siteMemberCnt,
  updateMemberCnt,
}) => {
  const location = useLocation();
  const isManager = useRecoilValue(isManagerValue) && !location.pathname.includes('minor');
  const customControl = useMemo(
    () => (
      <Button onClick={handleEditClick} type={'Third'} disabled={siteBasicInfo.siteStatCode === TERMINATED}>
        기본정보수정
      </Button>
    ),
    [handleEditClick, siteBasicInfo]
  );

  return (
    <FormAccordion
      label={'기본정보'}
      initialOpen
      buttonless
      description={'사이트 기본 정보를 확인할 수 있습니다.'}
      customControl={isManager ? customControl : <></>}
      noFold
    >
      <FlexBoxColumn width={'100%'} gap={'20px'}>
        <SiteBasicInfo siteBasicInfo={siteBasicInfo} jobGroupList={jobGroupList} />
        <ClientInfo siteBasicInfo={siteBasicInfo} subsidiaryList={subsidiaryList} />
        <DomainInfo siteBasicInfo={siteBasicInfo} redirectUrlList={redirectUrlList} />
        <MemberInfo
          siteBasicInfo={siteBasicInfo}
          siteMemberCnt={siteMemberCnt}
          setShowEntryMeanPopup={setShowEntryMeanPopup}
          setShowRegPopup={setShowRegPopup}
          updateMemberCnt={updateMemberCnt}
          subsidiaryList={subsidiaryList}
        />
        <SettleInfo siteBasicInfo={siteBasicInfo} />
        <EtcInfo siteBasicInfo={siteBasicInfo} applyExceptPayMeanList={applyExceptPayMeanList}/>
      </FlexBoxColumn>
    </FormAccordion>
  );
};

export default DetailSiteBasicInfo;

DetailSiteBasicInfo.propTypes = {
  handleEditClick: PropTypes.func,
  siteBasicInfo: PropTypes.object,
  subsidiaryList: PropTypes.arrayOf(PropTypes.object),
  jobGroupList: PropTypes.arrayOf(PropTypes.object),
  redirectUrlList: PropTypes.arrayOf(PropTypes.object),
  applyExceptPayMeanList: PropTypes.arrayOf(PropTypes.object),
  setShowEntryMeanPopup: PropTypes.func,
  setShowRegPopup: PropTypes.func,
  updateMemberCnt: PropTypes.func,
  siteMemberCnt: PropTypes.object,
};
